/* Cart slider acessible New Code */


  (function () {
    'use strict';
    var X = window.CDA11Y = window.CDA11Y || {};
    if (X.teardown) { try { X.teardown(); } catch (e) {} }

    X.d        = function () { return document.getElementById('occ3-drawer'); };
    X.isOpen   = function () { var d = X.d(); return !!d && /occ3-display-block/.test(String(d.className)); };
    X.carousel = function () { var d = X.d(); return d ? d.querySelector('.spurit-occ3__carousel') : null; };
    X.text     = function (e) { return e ? (e.textContent || '').trim().replace(/\s+/g, ' ') : ''; };
    X.uid      = function (p) { return p + Math.floor(Math.random() * 1e6); };

    /* ---------- polite announcer ---------- */
    X.say = function (msg) {
      var d = X.d(); if (!d) return;
      var l = d.querySelector('.cda11y-live');
      if (!l) {
        l = document.createElement('p');
        l.className = 'cda11y-live cda11y-sr';
        l.setAttribute('aria-live', 'polite');
        l.setAttribute('aria-atomic', 'true');
        d.appendChild(l);
      }
      l.textContent = (l.textContent === msg) ? msg + ' ' : msg;
    };

    X.nameForRow = function (el) {
      var row = el.closest('.spurit-occ3__item-row') || el.closest('.spurit-occ3__product-card') || el.closest('[class*="occ3__item"]');
      if (!row) return '';
      var t = row.querySelector('.spurit-occ3__item-title, a[class*="item-title"], a[class*="title"]');
      if (!t) t = [].slice.call(row.querySelectorAll('a')).filter(function (a) { return X.text(a).length > 2; })[0];
      var n = X.text(t);
      if (!n) { var im = row.querySelector('img[alt]'); n = im ? im.alt : ''; }
      return n;
    };

    /* ================= A. Drawer shell ================= */
    X.fixShell = function () {
      var d = X.d(); if (!d) return;

      // heading + dialog name
      var hdr = d.querySelector('.spurit-occ3__slide-drawer-header');
      if (hdr) {
        var span = [].slice.call(hdr.querySelectorAll('span')).filter(function (s) { return /Your Cart/i.test(X.text(s)); })[0];
        if (span && !span.getAttribute('role')) {
          span.setAttribute('role', 'heading');
          span.setAttribute('aria-level', '2');
          if (!span.id) span.id = 'cda11y-cart-heading';
          d.setAttribute('aria-labelledby', span.id);
          d.removeAttribute('aria-label');
        }
      }

      // *** line-item trash buttons are mislabelled "Close cart" ***
      [].slice.call(d.querySelectorAll('button[aria-label="Close cart"]')).forEach(function (b) {
        b.setAttribute('type', 'button');
        if (b.closest('.spurit-occ3__slide-drawer-header')) return;   // the genuine close button
        var name = X.nameForRow(b);
        b.setAttribute('aria-label', name ? 'Remove ' + name + ' from cart' : 'Remove item from cart');
        b.dataset.cda11yRemove = '1';
        if (!b.dataset.cda11yBound) {
          b.dataset.cda11yBound = '1';
          b.addEventListener('click', function () { X.say((name || 'Item') + ' removed from cart.'); });
        }
      });

      // notes textarea (placeholder-only labelling)
      [].slice.call(d.querySelectorAll('textarea')).forEach(function (ta) {
        if (!ta.getAttribute('aria-label') && !ta.getAttribute('aria-labelledby'))
          ta.setAttribute('aria-label', 'Order notes: special instructions for your order');
      });

      // decorative icons
      [].slice.call(d.querySelectorAll('svg:not([aria-hidden]):not([aria-label])')).forEach(function (s) {
        if (!s.querySelector('title')) { s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false'); }
      });

      // free-gift / reward progress bars
      [].slice.call(d.querySelectorAll('.occ3__bar-segment')).forEach(function (seg) {
        var fill = seg.querySelector('.occ3__bar-segment-progress-fill');
        var pct = 0;
        if (fill) {
          var w = parseFloat(getComputedStyle(fill).width), pw = parseFloat(getComputedStyle(fill.parentElement).width);
          if (pw > 0) pct = Math.round(w / pw * 100);
        }
        var bar = seg.closest('.occ3__reward-bar');
        var label = X.text(bar && bar.querySelector('.occ3__bar-title')) || 'Reward progress';
        var tile = seg.querySelector('[class*=tile], [class*=title]');
        seg.setAttribute('role', 'progressbar');
        seg.setAttribute('aria-valuemin', '0');
        seg.setAttribute('aria-valuemax', '100');
        seg.setAttribute('aria-valuenow', String(pct));
        seg.setAttribute('aria-valuetext', pct + '% towards ' + (X.text(tile) || 'this reward'));
        seg.setAttribute('aria-label', label);
      });
    };

    X.fixQty = function () {
      var d = X.d(); if (!d) return;
      [].slice.call(d.querySelectorAll('.spurit-num-input')).forEach(function (grp) {
        var name  = X.nameForRow(grp) || 'item';
        var minus = grp.querySelector('.spurit-ni-button-left');
        var plus  = grp.querySelector('.spurit-ni-button-right');
        var inp   = grp.querySelector('.occ3-quantity');
        if (minus) { minus.setAttribute('type', 'button'); minus.setAttribute('aria-label', 'Decrease quantity of ' + name); }
        if (plus)  { plus.setAttribute('type', 'button');  plus.setAttribute('aria-label', 'Increase quantity of ' + name); }
        if (inp)   { inp.setAttribute('aria-label', 'Quantity for ' + name); inp.setAttribute('inputmode', 'numeric'); if (!inp.getAttribute('min')) inp.setAttribute('min', '0'); }
      });
    };

    /* ========= B. "Frequently Purchased Together" carousel ========= */
    X.fixCarousel = function () {
      var car = X.carousel(); if (!car) return;
      var box = car.querySelector('.spurit-occ3__carousel-box');
      var track = car.querySelector('.spurit-occ3__carousel-items');
      var cards = [].slice.call(car.querySelectorAll('.spurit-occ3__product-card'));
      if (!box || !track || !cards.length) return;

      var titleSpan = (car.querySelector('.spurit-occ3__upsell-title') || {}).querySelector
                    ? car.querySelector('.spurit-occ3__upsell-title').querySelector('span') : null;
      if (titleSpan && !titleSpan.getAttribute('role')) {
        titleSpan.setAttribute('role', 'heading');
        titleSpan.setAttribute('aria-level', '3');
        if (!titleSpan.id) titleSpan.id = 'cda11y-fpt-heading';
      }
      if (!car.getAttribute('role')) {
        car.setAttribute('role', 'group');
        car.setAttribute('aria-roledescription', 'carousel');
        if (titleSpan && titleSpan.id) car.setAttribute('aria-labelledby', titleSpan.id);
        else car.setAttribute('aria-label', 'Frequently purchased together');
      }
      if (!track.getAttribute('role')) {
        track.setAttribute('role', 'list');
        track.setAttribute('aria-label', 'Recommended products');
      }

      cards.forEach(function (c, i) {
        if (!c.getAttribute('role')) c.setAttribute('role', 'listitem');
        c.setAttribute('aria-roledescription', 'slide');
        c.setAttribute('aria-label', 'Item ' + (i + 1) + ' of ' + cards.length);

        var title = c.querySelector('.spurit-occ3__item-title');
        var name  = X.text(title) || 'this product';

        // empty duplicate thumbnail link -> out of the tab order and the a11y tree
        var thumb = c.querySelector('.spurit-occ3__thumbnail');
        if (thumb && !thumb.textContent.trim()) {
          thumb.setAttribute('tabindex', '-1');
          thumb.setAttribute('aria-hidden', 'true');
        }
        var sel = c.querySelector('select');
        if (sel && !sel.getAttribute('aria-label')) sel.setAttribute('aria-label', 'Choose a size for ' + name);

        var btn = c.querySelector('button');
        if (btn) {
          btn.setAttribute('type', 'button');
          if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', 'Add ' + name + ' to cart');
          if (!btn.dataset.cda11yBound) {
            btn.dataset.cda11yBound = '1';
            btn.addEventListener('click', function () { X.say(name + ' added to cart.'); });
          }
        }
        var price = c.querySelector('[data-occ3="price-total"], .spurit-occ3-discounted-price');
        if (price && !price.dataset.cda11y) {
          price.dataset.cda11y = '1';
          var sr = document.createElement('span');
          sr.className = 'cda11y-sr';
          sr.textContent = 'Price: ';
          price.insertBefore(sr, price.firstChild);
        }
      });

      [].slice.call(car.querySelectorAll('.spurit-occ3__carousel-arrow')).forEach(function (a) {
        a.setAttribute('type', 'button');
        var isLeft = /_left/.test(String(a.className));
        if (!a.getAttribute('aria-label'))
          a.setAttribute('aria-label', isLeft ? 'Previous recommended product' : 'Next recommended product');
        a.dataset.cda11yDir = isLeft ? 'prev' : 'next';
        if (!a.dataset.cda11yBound) {
          a.dataset.cda11yBound = '1';
          a.addEventListener('click', function () { setTimeout(function () { X.syncCarousel(true); }, 350); });
        }
      });

      X.syncCarousel(false);
    };

    /* only on-screen slides stay focusable; kill the forced scroll that tore the layout */
    X.syncCarousel = function (speak) {
      var car = X.carousel(); if (!car) return;
      var box = car.querySelector('.spurit-occ3__carousel-box');
      var cards = [].slice.call(car.querySelectorAll('.spurit-occ3__product-card'));
      if (!box || !cards.length) return;
      if (box.scrollLeft !== 0) box.scrollLeft = 0;

      var br = box.getBoundingClientRect(), visible = [];
      cards.forEach(function (c, i) {
        var r = c.getBoundingClientRect();
        var vis = (r.left >= br.left - 4 && r.right <= br.right + 4);
        if (vis) visible.push(i + 1);
        if ('inert' in HTMLElement.prototype) { c.inert = !vis; }
        else {
          c.setAttribute('aria-hidden', vis ? 'false' : 'true');
          [].slice.call(c.querySelectorAll('a[href],button,select,input,textarea,[tabindex]')).forEach(function (e) {
            if (vis) {
              if (e.dataset.cda11yTi !== undefined) {
                if (e.dataset.cda11yTi === '') e.removeAttribute('tabindex'); else e.setAttribute('tabindex', e.dataset.cda11yTi);
                delete e.dataset.cda11yTi;
              }
            } else {
              if (e.dataset.cda11yTi === undefined) e.dataset.cda11yTi = e.getAttribute('tabindex') || '';
              e.setAttribute('tabindex', '-1');
            }
          });
        }
        var t = c.querySelector('.spurit-occ3__thumbnail');
        if (t && !t.textContent.trim()) { t.setAttribute('tabindex', '-1'); t.setAttribute('aria-hidden', 'true'); }
      });

      var first = visible[0] || 1, last = visible[visible.length - 1] || 1;
      [].slice.call(car.querySelectorAll('.spurit-occ3__carousel-arrow')).forEach(function (a) {
        var atEnd = a.dataset.cda11yDir === 'prev' ? (first <= 1) : (last >= cards.length);
        a.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      });

      if (speak && visible.length) {
        var c = cards[visible[0] - 1];
        var name = c ? X.text(c.querySelector('.spurit-occ3__item-title')) : '';
        X.say('Showing item ' + visible[0] + ' of ' + cards.length + (name ? ': ' + name : ''));
      }
    };

    /* ================= C. Modal hygiene ================= */
    X.bgNodes = function () {
      var d = X.d();
      return [].slice.call(document.body.children).filter(function (e) {
        return e !== d && !/^(SCRIPT|STYLE|LINK|META|TEMPLATE|NOSCRIPT)$/.test(e.tagName);
      });
    };
    X.lockBg = function () {
      X.bgNodes().forEach(function (e) {
        if (e.dataset.cda11yBg) return;
        e.dataset.cda11yBg = '1';
        e.dataset.cda11yPrevHidden = e.getAttribute('aria-hidden') || '';
        if ('inert' in HTMLElement.prototype) e.inert = true;
        e.setAttribute('aria-hidden', 'true');
      });
    };
    X.unlockBg = function () {
      [].slice.call(document.querySelectorAll('[data-cda11y-bg]')).forEach(function (e) {
        if ('inert' in HTMLElement.prototype) e.inert = false;
        if (e.dataset.cda11yPrevHidden) e.setAttribute('aria-hidden', e.dataset.cda11yPrevHidden);
        else e.removeAttribute('aria-hidden');
        delete e.dataset.cda11yBg; delete e.dataset.cda11yPrevHidden;
      });
    };

    X.findTrigger = function () {
      var d = X.d(); if (!d) return null;
      return [].slice.call(document.querySelectorAll('[aria-haspopup="dialog"],[data-cart-toggle],a[href*="/cart"]'))
        .filter(function (e) { return !d.contains(e) && e.getClientRects().length > 0; })[0] || null;
    };

    X.fixTrigger = function () {
      var t = X.findTrigger(), d = X.d(); if (!t || !d) return;
      t.setAttribute('aria-controls', d.id || 'occ3-drawer');
      t.setAttribute('aria-expanded', X.isOpen() ? 'true' : 'false');
      var n = (X.text(t).match(/\d+/) || [])[0];
      t.setAttribute('aria-label', 'Cart' + (n ? ', ' + n + ' item' + (n === '1' ? '' : 's') : '') + '. Opens cart drawer');
      [].slice.call(t.querySelectorAll('svg')).forEach(function (s) { s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false'); });
      [].slice.call(t.children).forEach(function (c) { if (/^\d+$/.test(X.text(c))) c.setAttribute('aria-hidden', 'true'); });
    };

    X.onOpen = function () {
      X.lockBg(); X.fixShell(); X.fixQty(); X.fixCarousel(); X.fixTrigger();
      var t = X.findTrigger(); if (t) t.setAttribute('aria-expanded', 'true');
      X.say('Shopping cart opened.');
    };
    X.onClose = function () {
      X.unlockBg();
      var t = X.findTrigger(); if (!t) return;
      t.setAttribute('aria-expanded', 'false');
      try { t.focus(); } catch (e) {}
      requestAnimationFrame(function () { try { t.focus(); } catch (e) {} });
      setTimeout(function () { var d = X.d(); if (d && d.contains(document.activeElement)) { try { t.focus(); } catch (e) {} } }, 120);
    };

    /* ================= D. Wiring ================= */
    X.onFocusIn = function (e) {
      var car = X.carousel(); if (!car || !car.contains(e.target)) return;
      var box = car.querySelector('.spurit-occ3__carousel-box');
      if (box && box.scrollLeft !== 0) box.scrollLeft = 0;
    };
    X.onScrollGuard = function (e) {
      var b = e.target;
      if (b && b.classList && b.classList.contains('spurit-occ3__carousel-box') && b.scrollLeft !== 0) b.scrollLeft = 0;
    };
    document.addEventListener('focusin', X.onFocusIn, true);
    document.addEventListener('scroll', X.onScrollGuard, true);

    X.wasOpen = X.isOpen();
    X.mo = new MutationObserver(function () {
      clearTimeout(X.t);
      X.t = setTimeout(function () {
        var open = X.isOpen();
        if (open && !X.wasOpen) X.onOpen();
        else if (!open && X.wasOpen) X.onClose();
        else if (open) { X.fixShell(); X.fixQty(); X.fixCarousel(); X.fixTrigger(); }
        X.wasOpen = open;
      }, 150);
    });

    X.lastSummary = '';
    X.summaryTimer = setInterval(function () {
      var d = X.d(); if (!d || !X.isOpen()) return;
      var h = d.querySelector('[role=heading][aria-level="2"]');
      var co = d.querySelector('a.spurit-occ3__btn');
      var sum = X.text(h) + ' | ' + X.text(co);
      if (X.lastSummary && sum !== X.lastSummary)
        X.say('Cart updated. ' + X.text(h) + '. Total ' + X.text(co).replace(/^Secure Checkout\s*/, ''));
      X.lastSummary = sum;
    }, 1200);

    X.teardown = function () {
      document.removeEventListener('focusin', X.onFocusIn, true);
      document.removeEventListener('scroll', X.onScrollGuard, true);
      if (X.mo) X.mo.disconnect();
      clearInterval(X.summaryTimer);
      X.unlockBg();
    };

    function boot() {
      var d = X.d(); if (!d) return false;
      X.mo.observe(d, { attributes: true, attributeFilter: ['class', 'style'], childList: true, subtree: true });
      X.fixTrigger();
      if (X.isOpen()) { X.lockBg(); X.fixShell(); X.fixQty(); X.fixCarousel(); }
      return true;
    }
    var tries = 0;
    var poll = setInterval(function () { if (boot() || ++tries > 40) clearInterval(poll); }, 500);
    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();

/* Cart slider acessible New Code Focus trapping on multiple product adding */

    (function () {
    if (window.CDFIX && window.CDFIX.teardown) { try { window.CDFIX.teardown(); } catch (e) {} }
    var F = window.CDFIX = {};
    F.SEL = '#occ3-drawer';
    F.busy = false; F.quiet = null; F.maxT = null;
    F.lastKey = null; F.lastTab = 0; F.restoring = false; F.lastSaid = '';

    F.d = function () { return document.querySelector(F.SEL); };
    F.isOpen = function () {
        var d = F.d(); if (!d) return false;
        var c = getComputedStyle(d);
        return c.display !== 'none' && c.visibility !== 'hidden';
    };
    F.host = function () {
        var d = F.d(); if (!d) return null;
        if (d.getAttribute('tabindex') === null) d.setAttribute('tabindex', '-1');
        return d;
    };

    /* ---- status messages (4.1.3) ---- */
    F.live = function () {
        var d = F.d(); if (!d) return null;
        var l = d.querySelector('.cdfix-live');
        if (!l) {
        l = document.createElement('div');
        l.className = 'cdfix-live cdfix-sr';
        l.setAttribute('role', 'status');
        l.setAttribute('aria-live', 'polite');
        l.setAttribute('aria-atomic', 'true');
        d.appendChild(l);
        }
        return l;
    };
    F.say = function (m) {
        if (m === F.lastSaid) return;
        F.lastSaid = m;
        var l = F.live(); if (!l) return;
        l.textContent = '';
        setTimeout(function () { l.textContent = m; }, 40);
    };

    /* ---- rebuild-proof identity for the focused control ---- */
    F.vidOf = function (el) {
        var card = el.closest('.spurit-occ3__product-card, .spurit-occ3__item-row');
        if (!card) return null;
        var q = card.querySelector('[data-vid]');
        return q ? q.getAttribute('data-vid') : null;
    };
    F.key = function (el) {
        var d = F.d();
        if (!el || !d || el === d || F.restoring || !d.contains(el)) return null;
        var vid = F.vidOf(el);
        var role = el.getAttribute('data-occ3') ||
                (el.getAttribute('class') || '').split(' ').filter(Boolean)[0] ||
                el.tagName.toLowerCase();
        if (vid) return 'v|' + vid + '|' + role;
        var al = el.getAttribute('aria-label'); if (al) return 'al|' + al;
        if (el.id) return 'id|' + el.id;
        var cls = (el.getAttribute('class') || '').split(' ').filter(Boolean)[0];
        if (!cls) return null;
        return 'cl|' + cls + '|' + Array.prototype.slice.call(d.getElementsByClassName(cls)).indexOf(el);
    };
    F.find = function (k) {
        var d = F.d(); if (!d || !k) return null;
        var p = k.split('|');
        try {
        if (p[0] === 'v') {
            var q = d.querySelector('[data-vid="' + p[1] + '"]'); if (!q) return null;
            var card = q.closest('.spurit-occ3__product-card, .spurit-occ3__item-row'); if (!card) return null;
            return card.querySelector('[data-occ3="' + p[2] + '"]') || card.querySelector('.' + CSS.escape(p[2]));
        }
        if (p[0] === 'al') return d.querySelector('[aria-label="' + p[1].replace(/"/g, '\\"') + '"]');
        if (p[0] === 'id') return d.querySelector('#' + CSS.escape(p[1]));
        if (p[0] === 'cl') { var a = d.getElementsByClassName(p[1]); return a[+p[2]] || a[0] || null; }
        } catch (e) {}
        return null;
    };

    /* ---- busy / settle cycle ---- */
    F.markBusy = function () {
        var d = F.d(); if (!d || F.busy) return;
        F.busy = true;
        d.setAttribute('aria-busy', 'true');
        F.say('Updating your cart, please wait.');
    };
    F.focusEl = function (el) {
        F.restoring = true;
        try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
        setTimeout(function () { F.restoring = false; }, 80);
    };
    F.restoreFocus = function (tries) {
        var d = F.d(); if (!d || !F.isOpen()) return;
        var a = document.activeElement;
        var lost = (!a || a === document.body || a === document.documentElement || a === d || !d.contains(a));
        if (!lost) return;
        var t = F.find(F.lastKey);
        if (t && t.offsetParent !== null) { F.focusEl(t); return; }
        if (tries > 0) { setTimeout(function () { F.restoreFocus(tries - 1); }, 350); return; }
        var h = F.host(); if (h) F.focusEl(h);
    };
    F.settle = function () {
        clearTimeout(F.maxT); F.maxT = null;
        var d = F.d(); if (!d) return;
        F.busy = false;
        d.setAttribute('aria-busy', 'false');
        if (!F.isOpen()) return;
        F.restoreFocus(6);
        var n = d.querySelector('.spurit-occ3__title');
        F.say((n ? n.textContent.trim().replace(/\s+/g, ' ') : 'Cart') + ' updated.');
    };

    /* ignore our own live region, otherwise aria-busy never clears */
    F.ignore = function (n) {
        while (n && n.nodeType) {
        if (n.nodeType === 1) {
            if (n.classList && n.classList.contains('cdfix-live')) return true;
            if (n.getAttribute && n.getAttribute('aria-live')) return true;
        }
        n = n.parentNode;
        }
        return false;
    };
    F.onMut = function (ms) {
        if (!F.isOpen()) return;
        var real = false;
        for (var i = 0; i < ms.length; i++) { if (!F.ignore(ms[i].target)) { real = true; break; } }
        if (!real) return;
        F.markBusy();
        clearTimeout(F.quiet);
        F.quiet = setTimeout(F.settle, 280);
        if (!F.maxT) F.maxT = setTimeout(function () { F.maxT = null; F.settle(); }, 2500);
    };

    /* keep Spurit's premature Close-button focus off a doomed node */
    F.onFocusIn = function (e) {
        var d = F.d(); if (!d || !d.contains(e.target) || F.restoring || e.target === d) return;
        var al = (e.target.getAttribute && e.target.getAttribute('aria-label') || '').toLowerCase();
        if (al.indexOf('close cart') === 0 && F.busy && (Date.now() - F.lastTab > 400)) {
        var h = F.host();
        if (h && h !== e.target) { F.focusEl(h); return; }
        }
        var k = F.key(e.target); if (k) F.lastKey = k;
    };
    F.onKey = function (e) { if (e.key === 'Tab') F.lastTab = Date.now(); };

    /* ---- wire up ---- */
    function boot() {
        var d = F.d(); if (!d) { setTimeout(boot, 500); return; }
        F.host(); F.live();
        F.mo = new MutationObserver(F.onMut);
        F.mo.observe(d, { childList: true, subtree: true });
        F.smo = new MutationObserver(function () {
        var o = F.isOpen();
        if (o && !F.wasOpen) {
            F.wasOpen = true; F.markBusy();
            clearTimeout(F.quiet); F.quiet = setTimeout(F.settle, 700);
        } else if (!o && F.wasOpen) {
            F.wasOpen = false; F.busy = false; d.setAttribute('aria-busy', 'false');
        }
        });
        F.smo.observe(d, { attributes: true, attributeFilter: ['style', 'class'] });
        document.addEventListener('focusin', F.onFocusIn, true);
        document.addEventListener('keydown', F.onKey, true);
        F.wasOpen = F.isOpen();
    }
    F.teardown = function () {
        try { F.mo.disconnect(); } catch (e) {}
        try { F.smo.disconnect(); } catch (e) {}
        document.removeEventListener('focusin', F.onFocusIn, true);
        document.removeEventListener('keydown', F.onKey, true);
        var d = F.d(); if (d) d.removeAttribute('aria-busy');
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
})();


/*==  cart slider quantity button focus trap === */

  (function($){
    var doc = $(document).get(0);
    doc.addEventListener('keydown', function(e){
      if (e.key === 'Tab' && e.target && e.target.classList && e.target.classList.contains('occ3-quantity')) {
        var focusable = $('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(function(){
          return this.offsetParent !== null; // only visible elements
        }).get();

        var idx = focusable.indexOf(e.target);
        if (idx !== -1) {
          var nextIdx = e.shiftKey ? idx - 1 : idx + 1;
          if (nextIdx >= 0 && nextIdx < focusable.length) {
            e.preventDefault();
            e.stopPropagation(); // stops the buggy handler from re-trapping focus
            focusable[nextIdx].focus();
          }
        }
      }
    }, true); // capture phase so this runs before the offending handler
})(jQuery);

/*=== Cart Focus management  =*/


    (function ($) {

        if (window.__adaCartFixLoaded) {
          console.warn('ADA CART: script already loaded once — skipping duplicate execution.');
          return;
        }
        window.__adaCartFixLoaded = true;

        function initCartFix($trigger) {

          var lastFocusedBeforeOpen = null;

          $trigger
            .removeAttr('href')
            .attr({
              'role': 'button',
              'tabindex': '0',
              'aria-haspopup': 'dialog',
              'aria-expanded': 'false'
            })
            .off('keydown.cartTrigger')
            .on('keydown.cartTrigger', function (e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.click();
              }
            });

          var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), ' +
            'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

          function getRealFocusable($scope) {
            return $scope.find(focusableSelector).filter(function () {
              var rect = this.getBoundingClientRect();
              var style = window.getComputedStyle(this);
              return rect.width > 0 &&
                    rect.height > 0 &&
                    style.visibility !== 'hidden' &&
                    style.display !== 'none' &&
                    parseFloat(style.opacity) > 0;
            });
          }

          function isDrawerOpen() {
            var $d = $('#occ3-drawer');
            return $d.length > 0 && $d.hasClass('occ3-display-block');
          }

          function focusCloseButtonWhenReady() {
            var attempts = 0;
            var maxAttempts = 30;
            var tryFocus = setInterval(function () {
              attempts++;
              var $drawer = $('#occ3-drawer');
              var $closeBtn = getRealFocusable($drawer).filter('[data-occ3="close-cart"]').first();
              if ($closeBtn.length) {
                $closeBtn[0].focus();
                clearInterval(tryFocus);
                console.log('ADA CART: focus moved to close button?', document.activeElement === $closeBtn[0]);
              } else if (attempts >= maxAttempts) {
                clearInterval(tryFocus);
                console.warn('ADA CART: gave up waiting for a focusable close button.');
              }
            }, 100);
          }

          function trapFocus(e) {
            if (e.key !== 'Tab') return;
            var $openDrawer = $('#occ3-drawer').filter(':visible');
            if (!$openDrawer.length) return;
            var $focusable = getRealFocusable($openDrawer);
            if (!$focusable.length) return;

            var first = $focusable[0];
            var last = $focusable[$focusable.length - 1];

            if (e.shiftKey && document.activeElement === first) {
              e.preventDefault();
              last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }

          function escHandler(e) {
            if (e.key === 'Escape') {
              $('[data-occ3="close-cart"]').first().trigger('click');
            }
          }

          function onDrawerOpen() {
            console.log('ADA CART: drawer OPEN detected.');
            lastFocusedBeforeOpen = document.activeElement;
            $trigger.attr('aria-expanded', 'true');
            focusCloseButtonWhenReady();
            $(document).off('keydown.cartTrap keydown.cartEsc');
            $(document).on('keydown.cartTrap', trapFocus);
            $(document).on('keydown.cartEsc', escHandler);
          }

          function onDrawerClose() {
            console.log('ADA CART: drawer CLOSE detected.');
            $trigger.attr('aria-expanded', 'false');
            $(document).off('keydown.cartTrap keydown.cartEsc');
            if (lastFocusedBeforeOpen && document.body.contains(lastFocusedBeforeOpen)) {
              lastFocusedBeforeOpen.focus();
            }
          }

          var wasOpen = isDrawerOpen();
          console.log('ADA CART: cart-fix initialized successfully. Drawer initially open?', wasOpen);

          var observer = new MutationObserver(function () {
            var isOpenNow = isDrawerOpen();
            if (isOpenNow && !wasOpen) {
              onDrawerOpen();
            } else if (!isOpenNow && wasOpen) {
              onDrawerClose();
            }
            wasOpen = isOpenNow;
          });

          observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true,
            childList: true
          });
        }

        // ---- Wait for the trigger element to actually exist before doing anything ----
        function waitForCartTrigger() {
          var $trigger = jQuery('[data-occ3-cart-icon]');
          if ($trigger.length) {
            console.log('ADA CART: trigger found, initializing.');
            initCartFix($trigger);
            return;
          }
          console.log('ADA CART: trigger not yet in DOM, watching for it...');
          var elementWaitObserver = new MutationObserver(function () {
            var $t = jQuery('[data-occ3-cart-icon]');
            if ($t.length) {
              elementWaitObserver.disconnect();
              console.log('ADA CART: trigger appeared, initializing.');
              initCartFix($t);
            }
          });
          elementWaitObserver.observe(document.body, { childList: true, subtree: true });
        }

        jQuery(function () {
          waitForCartTrigger();
        });

    })(jQuery);

/*=== Fix cart total product count and restoring focus on button and cart icon   =*/

    (function () {

    /* ---------- shared: reliable open/close detection ---------- */
    function occ3IsOpen() {
        var d = document.querySelector('#occ3-drawer'); if (!d) return false;
        var p = d.querySelector('.spurit-occ3__slide-drawer'); if (!p) return false;
        var cs = getComputedStyle(p);
        if (cs.display === 'none' || cs.visibility === 'hidden') return false;
        var r = p.getBoundingClientRect();
        if (!r.width || !r.height) return false;
        return r.left < (window.innerWidth - 8) && r.right > 8;
    }
    window.occ3IsOpen = occ3IsOpen;

    /* ================= 1. CART COUNT SYNC ================= */
    if (window.CCSYNC && window.CCSYNC.teardown) { try { window.CCSYNC.teardown(); } catch (e) {} }
    var C = window.CCSYNC = {};
    C.RX = /\/cart\/(add|change|update|clear)(\.js)?/i;
    C.timer = null; C.lastN = null;

    C.badges = function () {
        return Array.prototype.slice.call(document.querySelectorAll('[x-text="cart.item_count"]'))
        .filter(function (e) { return !e.closest('#occ3-drawer'); });
    };
    C.trigger = function () {
        return document.querySelector('[data-occ3-cart-icon]') ||
            document.querySelector('a.type__nav[aria-haspopup="dialog"]') ||
            document.querySelector('a.type__nav');
    };
    C.live = function () {
        var l = document.getElementById('ccsync-live');
        if (!l) {
        l = document.createElement('div');
        l.id = 'ccsync-live'; l.className = 'ccsync-sr';
        l.setAttribute('role', 'status');
        l.setAttribute('aria-live', 'polite');
        l.setAttribute('aria-atomic', 'true');
        document.body.appendChild(l);
        }
        return l;
    };
    C.paint = function (n) {
        C.badges().forEach(function (e) {
        if (e.textContent.trim() !== String(n)) e.textContent = String(n);
        });
        var t = C.trigger();
        if (t) {
        t.setAttribute('aria-label',
            n === 0 ? 'Cart, empty. Opens cart drawer'
                    : 'Cart, ' + n + ' item' + (n === 1 ? '' : 's') + '. Opens cart drawer');
        t.removeAttribute('title');           /* title was masking the name */
        }
        if (C.lastN !== null && C.lastN !== n) {
        var l = C.live(); l.textContent = '';
        setTimeout(function () {
            l.textContent = 'Cart updated. ' + n + ' item' + (n === 1 ? '' : 's') + ' in cart.';
        }, 60);
        }
        C.lastN = n;
    };
    C.sync = function () {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
            try {
            var app = window.Alpine && window.Alpine.$data(document.documentElement);
            if (app && app.cart) {
                app.cart.item_count           = c.item_count;
                app.cart.total_price          = c.total_price;
                app.cart.original_total_price = c.original_total_price;
                app.cart.total_discount       = c.total_discount;
                app.cart.items                = c.items;
            }
            } catch (e) {}
            requestAnimationFrame(function () { C.paint(c.item_count); });
            setTimeout(function () { C.paint(c.item_count); }, 400);  /* beat the Liquid re-render */
        })
        .catch(function () {});
    };
    C.schedule = function () { clearTimeout(C.timer); C.timer = setTimeout(C.sync, 350); };

    /* hook every cart mutation, whoever makes it */
    C.origFetch = window.fetch;
    window.fetch = function () {
        var url = '';
        try { url = (typeof arguments[0] === 'string') ? arguments[0] : (arguments[0] && arguments[0].url) || ''; } catch (e) {}
        var p = C.origFetch.apply(this, arguments);
        if (C.RX.test(url)) { try { p.then(function () { C.schedule(); }).catch(function () {}); } catch (e) { C.schedule(); } }
        return p;
    };
    C.origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) { try { this.__ccUrl = u; } catch (e) {} return C.origOpen.apply(this, arguments); };
    C.origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
        try { if (C.RX.test(this.__ccUrl || '')) this.addEventListener('loadend', function () { C.schedule(); }); } catch (e) {}
        return C.origSend.apply(this, arguments);
    };
    C.teardown = function () {
        window.fetch = C.origFetch;
        XMLHttpRequest.prototype.open = C.origOpen;
        XMLHttpRequest.prototype.send = C.origSend;
        clearTimeout(C.timer);
    };
    C.sync();

    /* ============ 2. OPENER-AWARE FOCUS RETURN ============ */
    if (window.CDOPEN && window.CDOPEN.teardown) { try { window.CDOPEN.teardown(); } catch (e) {} }
    var O = window.CDOPEN = {};
    O.SEL = '#occ3-drawer';
    O.pending = null; O.pendingAt = 0; O.opener = null; O.openerForm = null;
    O.isOpen = occ3IsOpen;

    O.visible = function (el) {
        if (!el || !el.isConnected || el.closest('[inert]')) return false;
        var r = el.getBoundingClientRect();
        if (!r.width && !r.height) return false;
        var cs = getComputedStyle(el);
        return cs.visibility !== 'hidden' && cs.display !== 'none';
    };
    O.candidate = function (t) {
        if (!t || !t.closest) return null;
        var el = t.closest('button, a, [role="button"], input[type="submit"], [data-occ3-atc-button], [data-occ3-cart-icon]');
        if (!el || el.closest(O.SEL)) return null;
        return el;
    };
    O.note = function (e) {
        var el = O.candidate(e.target);
        if (el) { O.pending = el; O.pendingAt = Date.now(); }
    };
    O.onPointer = function (e) { O.note(e); };
    O.onKey = function (e) { if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') O.note(e); };
    O.onSubmit = function (e) {
        var f = e.target;
        if (!f || f.tagName !== 'FORM' || f.closest(O.SEL)) return;
        var b = f.querySelector('[data-occ3-atc-button]') || f.querySelector('button[type="submit"]');
        if (b) { O.pending = b; O.pendingAt = Date.now(); }
    };

    O.captureOpener = function () {
        var el = (Date.now() - O.pendingAt < 5000) ? O.pending : null;
        document.querySelectorAll('[data-cdfix-opener]').forEach(function (n) { n.removeAttribute('data-cdfix-opener'); });
        if (el) {
        el.setAttribute('data-cdfix-opener', '1');   /* survives label swaps */
        O.opener = el;
        O.openerForm = el.closest('form') || null;
        } else { O.opener = null; O.openerForm = null; }
    };
    O.resolve = function () {
        var stamped = document.querySelector('[data-cdfix-opener]');
        if (O.visible(stamped)) return stamped;
        if (O.visible(O.opener)) return O.opener;
        if (O.openerForm && O.openerForm.isConnected) {          /* button was re-rendered */
        var b = O.openerForm.querySelector('[data-occ3-atc-button]');
        if (O.visible(b)) return b;
        var list = O.openerForm.querySelectorAll('button[type="submit"], [data-occ3-atc-button]');
        for (var i = 0; i < list.length; i++) if (O.visible(list[i])) return list[i];
        }
        var icon = document.querySelector('[data-occ3-cart-icon]') ||
                document.querySelector('a.type__nav[aria-haspopup="dialog"]');
        return O.visible(icon) ? icon : null;
    };
    O.restore = function () {
        var t = O.resolve(); if (!t) return;
        var put = function () {
        if (O.isOpen() || document.activeElement === t) return;
        try { t.focus({ preventScroll: false }); } catch (e) { t.focus(); }
        };
        requestAnimationFrame(put);
        setTimeout(put, 120);
        setTimeout(put, 320);
        setTimeout(function () {
        put();
        document.querySelectorAll('[data-cdfix-opener]').forEach(function (n) { n.removeAttribute('data-cdfix-opener'); });
        }, 600);
    };

    document.addEventListener('pointerdown', O.onPointer, true);
    document.addEventListener('keydown',     O.onKey,     true);
    document.addEventListener('submit',      O.onSubmit,  true);

    O.wasOpen = O.isOpen();
    /* Spurit emits no open/close event and leaves role/aria-modal on permanently,
        so a cheap 100ms state poll is the only reliable trigger. */
    O.poll = setInterval(function () {
        var open = O.isOpen();
        if (open && !O.wasOpen)      { O.wasOpen = true;  O.captureOpener(); }
        else if (!open && O.wasOpen) { O.wasOpen = false; O.restore(); }
    }, 100);

    O.teardown = function () {
        clearInterval(O.poll);
        document.removeEventListener('pointerdown', O.onPointer, true);
        document.removeEventListener('keydown',     O.onKey,     true);
        document.removeEventListener('submit',      O.onSubmit,  true);
    };
})();

/*===  Inform the user about the product is added to the cart   =*/

    (function () {
    if (window.CARTNOTIFY && window.CARTNOTIFY.teardown) { try { window.CARTNOTIFY.teardown(); } catch (e) {} }
    var N = window.CARTNOTIFY = {};
    N.prev = null; N.hideT = null; N.t = null; N.busy = false;

    /* ---------- data ---------- */
    N.money = function (cents) {
        try { return window.Shopify.formatMoney(cents); } catch (e) { return (cents / 100).toFixed(2); }
    };
    N.index = function (c) {
        var m = {};
        c.items.forEach(function (i) {
        m[i.key] = {
            q: i.quantity,
            title: i.product_title,
            variant: (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '',
            line: i.final_line_price, unit: i.final_price
        };
        });
        return { map: m, count: c.item_count, total: c.total_price };
    };
    N.name = function (it) { return it.variant ? (it.title + ', ' + it.variant) : it.title; };

    N.diff = function (a, b) {
        if (!a) return null;
        var changes = [], k;
        for (k in b.map) {
        var was = a.map[k] ? a.map[k].q : 0;
        if (b.map[k].q !== was) {
            changes.push({
            type: was === 0 ? 'added' : (b.map[k].q > was ? 'increased' : 'decreased'),
            delta: Math.abs(b.map[k].q - was), it: b.map[k]
            });
        }
        }
        for (k in a.map) { if (!b.map[k]) changes.push({ type: 'removed', delta: a.map[k].q, it: a.map[k] }); }
        return changes.length ? changes : null;
    };

    N.compose = function (changes, snap) {
        var c = changes[0], title, body;
        var plural = function (n) { return n === 1 ? 'item' : 'items'; };
        if (changes.length > 1) {
        title = 'Cart updated';
        body  = changes.length + ' items in your cart were changed.';
        } else if (c.type === 'added' || c.type === 'increased') {
        title = 'Added to cart';
        body  = c.delta + ' × ' + N.name(c.it) + (c.type === 'increased'
                    ? ' added. You now have ' + c.it.q + ' of this item.'
                    : ' added to your cart.');
        } else if (c.type === 'decreased') {
        title = 'Quantity reduced';
        body  = c.delta + ' × ' + N.name(c.it) + ' removed. ' + c.it.q + ' still in your cart.';
        } else {
        title = 'Removed from cart';
        body  = N.name(c.it) + ' was removed from your cart.';
        }
        return {
        title: title, body: body,
        meta: 'Cart subtotal ' + N.money(snap.total) + ' · ' + snap.count + ' ' + plural(snap.count) + ' in cart.'
        };
    };

    /* ---------- UI (the toast IS the live region) ---------- */
    N.toast = function () {
        var t = document.getElementById('cn-toast');
        if (t) return t;
        t = document.createElement('div');
        t.id = 'cn-toast';
        t.setAttribute('role', 'status');
        t.setAttribute('aria-live', 'polite');
        t.setAttribute('aria-atomic', 'true');
        t.innerHTML =
        '<p class="cn-title"></p><p class="cn-body"></p><p class="cn-meta"></p>' +
        '<button type="button" class="cn-link">View cart</button>' +
        '<button type="button" class="cn-close" aria-label="Dismiss cart notification">&times;</button>';
        document.body.appendChild(t);
        t.querySelector('.cn-close').addEventListener('click', function () { N.hide(true); });
        t.querySelector('.cn-link').addEventListener('click', function () {
        var icon = document.querySelector('[data-occ3-cart-icon]') ||
                    document.querySelector('a.type__nav[aria-haspopup="dialog"]');
        N.hide(true); if (icon) icon.click();
        });
        t.addEventListener('mouseenter', function () { clearTimeout(N.hideT); });
        t.addEventListener('focusin',    function () { clearTimeout(N.hideT); });
        t.addEventListener('mouseleave', function () { N.arm(); });
        t.addEventListener('focusout',   function () { N.arm(); });
        return t;
    };
    N.arm  = function () { clearTimeout(N.hideT); N.hideT = setTimeout(function () { N.hide(false); }, 9000); };
    N.hide = function (byUser) {
        clearTimeout(N.hideT);
        var t = document.getElementById('cn-toast'); if (!t) return;
        t.classList.remove('cn-show');
        if (byUser) { var a = document.activeElement; if (a && t.contains(a)) { try { a.blur(); } catch (e) {} } }
        setTimeout(function () {
        if (!t.classList.contains('cn-show')) {
            t.querySelector('.cn-title').textContent = '';
            t.querySelector('.cn-body').textContent  = '';
            t.querySelector('.cn-meta').textContent  = '';
        }
        }, 400);
    };

    /* keep the toast out of the modal's inert background */
    N.drawerOpen = function () { try { return window.CDOPEN && window.CDOPEN.isOpen(); } catch (e) { return false; } };
    N.reparent = function (t) {
        var d = document.querySelector('#occ3-drawer');
        var host = (N.drawerOpen() && d) ? d : document.body;
        if (t.parentElement !== host) host.appendChild(t);
        t.removeAttribute('inert');
        t.removeAttribute('aria-hidden');
    };
    N.show = function (msg) {
        var t = N.toast();
        N.reparent(t);
        t.querySelector('.cn-title').textContent = msg.title;
        t.querySelector('.cn-body').textContent  = msg.body;
        t.querySelector('.cn-meta').textContent  = msg.meta;
        t.classList.add('cn-show');
        N.arm();
    };

    /* ---------- trigger ---------- */
    N.check = function () {
        if (N.busy) return; N.busy = true;
        fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
            var snap = N.index(c);
            var ch = N.diff(N.prev, snap);
            N.prev = snap;
            if (ch) N.show(N.compose(ch, snap));
        })
        .catch(function () {})
        .then(function () { N.busy = false; });
    };
    N.schedule = function () { clearTimeout(N.t); N.t = setTimeout(N.check, 500); };

    /* prime baseline so no toast fires on page load */
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { N.prev = N.index(c); });

    if (window.CCSYNC && typeof window.CCSYNC.schedule === 'function') {
        N.origSchedule = window.CCSYNC.schedule;
        window.CCSYNC.schedule = function () { N.origSchedule.apply(this, arguments); N.schedule(); };
        /* silence CCSYNC's own message so nothing is announced twice */
        N.origPaint = window.CCSYNC.paint;
        window.CCSYNC.paint = function (n) {
        N.origPaint.call(window.CCSYNC, n);
        var l = document.getElementById('ccsync-live'); if (l) l.textContent = '';
        };
        N.mode = 'via CCSYNC';
    } else {
        N.mode = 'standalone';   /* add your own /cart/(add|change|update) hook here */
    }

    N.wasOpen = N.drawerOpen();
    N.guard = setInterval(function () {
        var t = document.getElementById('cn-toast'); if (!t) return;
        var open = N.drawerOpen();
        if (open !== N.wasOpen) {
        N.wasOpen = open;
        var visible = t.classList.contains('cn-show');
        N.reparent(t);
        if (visible) t.classList.add('cn-show');
        }
        if (t.hasAttribute('inert')) t.removeAttribute('inert');
        if (t.getAttribute('aria-hidden') === 'true') t.removeAttribute('aria-hidden');
    }, 200);

    N.teardown = function () {
        clearInterval(N.guard); clearTimeout(N.t); clearTimeout(N.hideT);
        if (N.origSchedule) window.CCSYNC.schedule = N.origSchedule;
        if (N.origPaint)    window.CCSYNC.paint    = N.origPaint;
        var t = document.getElementById('cn-toast'); if (t) t.remove();
    };
})();

/* ---- QAFIX : quick-add keyboard + focus handoff ---- */
    (function () {
    if (window.QAFIX && window.QAFIX.teardown) { try { window.QAFIX.teardown(); } catch (e) {} }
    var Q = {}; window.QAFIX = Q;

    Q.QA  = '.product-quick-add';
    Q.ACT = 'button,[role="button"],[role="radio"],[role="tab"],a[href],summary,[role="link"]';
    Q.TAB = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]';
    Q.trigger = null; Q.pending = null; Q.armed = false; Q.inertEl = null;
    Q.timers = []; Q.keepUntil = 0;

    /* helpers */
    Q.vis = function (el) {
        if (!el || !el.isConnected) return false;
        var r = el.getBoundingClientRect();
        if (r.width <= 0 && r.height <= 0) return false;
        var c = getComputedStyle(el);
        return c.display !== 'none' && c.visibility !== 'hidden';
    };
    /* #occ3-drawer keeps display:block + role=dialog even when closed, so measure the panel */
    Q.drawerOpen = function () {
        try { if (window.CDOPEN && window.CDOPEN.isOpen) return !!window.CDOPEN.isOpen(); } catch (e) {}
        var d = document.querySelector('.spurit-occ3__slide-drawer');
        if (!d) return false;
        var r = d.getBoundingClientRect();
        return r.left < window.innerWidth - 8 && r.right > 8;
    };
    Q.dlgOpen = function () {
        var n = document.querySelectorAll(Q.QA);
        for (var i = 0; i < n.length; i++) if (Q.vis(n[i])) return n[i];
        return null;
    };
    Q.live = function () {
        var n = document.getElementById('qafix-live');
        if (!n) {
        n = document.createElement('div');
        n.id = 'qafix-live'; n.className = 'qa-sr';
        n.setAttribute('role', 'status');
        n.setAttribute('aria-live', 'polite');
        n.setAttribute('aria-atomic', 'true');
        document.body.appendChild(n);
        }
        return n;
    };
    Q.say = function (t) { var n = Q.live(); n.textContent = ''; setTimeout(function () { n.textContent = t; }, 60); };
    Q.clear = function () { Q.timers.forEach(clearTimeout); Q.timers = []; };
    Q.at = function (ms, fn) { Q.timers.push(setTimeout(fn, ms)); };
    Q.focus = function (el) {
        if (!el || !el.isConnected) return false;
        try {
        if (el.tabIndex < 0 && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(el.tagName)) el.setAttribute('tabindex', '-1');
        el.focus({ preventScroll: false });
        } catch (e) { return false; }
        return document.activeElement === el;
    };
    Q.tabbables = function (root) {
        return [].slice.call(root.querySelectorAll(Q.TAB)).filter(function (e) {
        var t = e.getAttribute('tabindex');
        if (t !== null && parseInt(t, 10) < 0) return false;
        if (e.closest('[inert]')) return false;
        if (e.getAttribute('aria-hidden') === 'true') return false;
        var r = e.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
        });
    };

    /* 1. restore Enter activation where the form cancels it */
    Q.enterBlocked = function (el) {
        if (el.closest(Q.QA)) return true;
        var f = el.closest('form');
        return !!(f && (f.hasAttribute('x-on:keydown.enter.prevent') || f.hasAttribute('@keydown.enter.prevent')));
    };
    Q.onEnter = function (ev) {
        if (ev.key !== 'Enter' || ev.altKey || ev.metaKey || ev.ctrlKey) return;
        var t = ev.target; if (!t || !t.closest) return;
        if (t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable) return;
        if (t.tagName === 'INPUT' && !/^(button|submit|reset|checkbox|radio)$/i.test(t.type || '')) return; /* keep Enter-in-text-field suppressed */
        var el = t.closest(Q.ACT);
        if (!el || !Q.enterBlocked(el)) return;
        if (el.disabled || el.getAttribute('aria-disabled') === 'true') return;
        ev.preventDefault();      /* we own the activation */
        ev.stopPropagation();     /* so no theme handler double-fires */
        if (ev.repeat) return;
        try { el.click(); } catch (e) {}
    };
    document.addEventListener('keydown', Q.onEnter, true);

    /* 2. remember which card button opened the quick-add dialog */
    Q.noteTrigger = function (t) {
        if (!t || !t.closest) return;
        var el = t.closest('[aria-haspopup="dialog"],button,a[href]');
        if (!el || el.closest(Q.QA) || el.closest('#occ3-drawer')) return;
        if (!/select size|quick add|choose options/i.test((el.textContent || '') + ' ' + (el.getAttribute('aria-label') || ''))) return;
        Q.trigger = el;
    };
    Q.onDown    = function (ev) { Q.noteTrigger(ev.target); };
    Q.onKeyTrig = function (ev) { if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') Q.noteTrigger(ev.target); };
    document.addEventListener('pointerdown', Q.onDown, true);
    document.addEventListener('keydown', Q.onKeyTrig, true);

    /* 3. remember an add that came from inside the dialog */
    Q.onClick = function (ev) {
        var t = ev.target; if (!t || !t.closest) return;
        var b = t.closest('[data-occ3-atc-button],button[type="submit"]'); if (!b) return;
        var d = b.closest(Q.QA); if (!d) return;
        Q.pending = { t: Date.now(), atc: b, dlg: d, trigger: Q.trigger };
    };
    document.addEventListener('click', Q.onClick, true);

    /* 4. live focus trap (window capture beats the app's stale cached trap) */
    Q.onTab = function (ev) {
        if (ev.key !== 'Tab') return;
        var d = document.getElementById('occ3-drawer');
        var host = (d && Q.drawerOpen()) ? d : Q.dlgOpen();
        if (!host) return;
        var a = document.activeElement;
        if (!a || !host.contains(a)) return;
        var list = Q.tabbables(host);
        if (list.length < 2) return;
        var i = list.indexOf(a), n;
        if (i === -1) n = ev.shiftKey ? list[list.length - 1] : list[0];
        else          n = ev.shiftKey ? list[(i - 1 + list.length) % list.length] : list[(i + 1) % list.length];
        ev.preventDefault(); ev.stopPropagation();
        try { n.focus(); } catch (e) {}
    };
    window.addEventListener('keydown', Q.onTab, true);

    /* 5. hand focus to the drawer, then give it back */
    Q.drawerTarget = function () {
        var d = document.getElementById('occ3-drawer'); if (!d) return null;
        var o = ['#cda11y-cart-heading', '[role="heading"]', 'h1', 'h2', '.spurit-occ3__slide-drawer-header'];
        for (var i = 0; i < o.length; i++) {
        var h = d.querySelector(o[i]);
        if (h && Q.vis(h)) { h.setAttribute('tabindex', '-1'); return h; }
        }
        var c = d.querySelector('[aria-label="Close cart"],.spurit-occ3__btn_plain');
        return c && Q.vis(c) ? c : null;
    };
    Q.restoreTarget = function () {
        var p = Q.pending || {};
        if (p.dlg && Q.vis(p.dlg) && p.atc && p.atc.isConnected && Q.vis(p.atc)) return p.atc;
        var t = p.trigger || Q.trigger;
        if (t && t.isConnected) return t;
        return document.querySelector('[data-occ3-cart-icon]');
    };
    Q.onDrawerOpen = function () {
        if (!Q.pending || Date.now() - Q.pending.t > 9000) { Q.pending = null; return; }
        Q.armed = true;
        var d = Q.pending.dlg;
        if (d && Q.vis(d)) { d.setAttribute('inert', ''); d.setAttribute('aria-hidden', 'true'); Q.inertEl = d; }
        Q.clear();
        Q.keepUntil = Date.now() + 4000;              /* survives the ~2.4 s drawer rebuild */
        Q.at(60,  function () { var t = Q.drawerTarget(); if (t) Q.focus(t); });
        Q.at(700, function () { Q.say('Cart drawer opened.'); });
    };
    Q.onDrawerClose = function () {
        Q.keepUntil = 0;
        if (Q.inertEl) { Q.inertEl.removeAttribute('inert'); Q.inertEl.removeAttribute('aria-hidden'); Q.inertEl = null; }
        if (!Q.armed) return;
        var tgt = Q.restoreTarget(); Q.clear();
        [0, 120, 350, 650, 950].forEach(function (ms) {
        Q.at(ms, function () {
            if (Q.drawerOpen()) return;
            if (tgt && tgt.isConnected && document.activeElement !== tgt) Q.focus(tgt);
        });
        });
        Q.at(1000, function () { Q.armed = false; Q.pending = null; });
    };
    Q.keeper = function () {
        if (Date.now() > Q.keepUntil || !Q.drawerOpen()) return;
        var d = document.getElementById('occ3-drawer'); if (!d) return;
        var t = Q.drawerTarget(); if (!t) return;
        var a = document.activeElement;
        if (a && a !== document.body && d.contains(a)) {
        var landing = a.getAttribute && a.getAttribute('tabindex') === '-1';
        if (!landing || a === t) return;            /* user is driving — leave them alone */
        }
        Q.focus(t);
    };

    /* 6. Escape closes the quick-add dialog and returns focus */
    Q.closeDialog = function (dlg) {
        var b = [].slice.call(dlg.querySelectorAll('button')).filter(function (x) {
        return /close/i.test((x.getAttribute('aria-label') || '') + ' ' + (x.getAttribute('title') || ''));
        })[0];
        if (b) { try { b.click(); return true; } catch (e) {} }
        return false;
    };
    Q.onEsc = function (ev) {
        if (ev.key !== 'Escape' && ev.key !== 'Esc') return;
        if (Q.drawerOpen()) return;                   /* the drawer owns Escape first */
        var dlg = Q.dlgOpen(); if (!dlg) return;
        var a = document.activeElement;
        if (!dlg.contains(ev.target) && (!a || !dlg.contains(a))) return;
        ev.preventDefault(); ev.stopPropagation();
        var t = Q.trigger;
        Q.closeDialog(dlg);
        Q.at(60,  function () { if (t && t.isConnected) Q.focus(t); });
        Q.at(280, function () { if (t && t.isConnected && document.activeElement === document.body) Q.focus(t); });
    };
    document.addEventListener('keydown', Q.onEsc, true);

    /* keep CDOPEN in agreement instead of fighting over the restore target */
    if (window.CDOPEN && window.CDOPEN.resolve && !window.CDOPEN.__qaWrapped) {
        var orig = window.CDOPEN.resolve.bind(window.CDOPEN);
        window.CDOPEN.resolve = function () {
        if (Q.armed) { var t = Q.restoreTarget(); if (t) return t; }
        return orig();
        };
        window.CDOPEN.__qaWrapped = true;
    }

    Q.wasOpen = Q.drawerOpen();
    Q.qaWasOpen = !!Q.dlgOpen();
    Q.poll = function () {
        var open = Q.drawerOpen();
        if (open && !Q.wasOpen) Q.onDrawerOpen();
        if (!open && Q.wasOpen) Q.onDrawerClose();
        Q.wasOpen = open;
        var dl = !!Q.dlgOpen();
        if (!dl && Q.qaWasOpen && !Q.armed && !open) {
        var t = Q.trigger, a = document.activeElement;
        if (t && t.isConnected && (!a || a === document.body || a === document.documentElement)) Q.focus(t);
        }
        Q.qaWasOpen = dl;
    };
    Q.iv     = setInterval(Q.poll, 100);
    Q.ivKeep = setInterval(Q.keeper, 120);

    Q.teardown = function () {
        clearInterval(Q.iv); clearInterval(Q.ivKeep); Q.clear();
        document.removeEventListener('keydown', Q.onEnter, true);
        document.removeEventListener('pointerdown', Q.onDown, true);
        document.removeEventListener('keydown', Q.onKeyTrig, true);
        document.removeEventListener('click', Q.onClick, true);
        document.removeEventListener('keydown', Q.onEsc, true);
        window.removeEventListener('keydown', Q.onTab, true);
        if (Q.inertEl) { Q.inertEl.removeAttribute('inert'); Q.inertEl.removeAttribute('aria-hidden'); }
        var s = document.getElementById('qafix-styles'); if (s) s.remove();
    };
})();

/* ---- CDHIDE : take the closed cart drawer out of the tab order and the a11y tree ---- */ 
    (function () {
  if (window.CDHIDE && window.CDHIDE.teardown) { try { window.CDHIDE.teardown(); } catch (e) {} }
  var H = {}; window.CDHIDE = H;

  H.PANEL = '.spurit-occ3__slide-drawer';
  H.FOCUSABLE = 'a[href],area[href],button,input,select,textarea,iframe,object,embed,summary,' +
                'audio[controls],video[controls],[contenteditable],[tabindex]';
  H.hasInert = ('inert' in HTMLElement.prototype);
  H.state = null;
  H.hideT = null;
  H.CLOSE_DELAY = 420;               /* let the slide-out animation finish first */

  H.drawer = function () { return document.getElementById('occ3-drawer'); };

  /* the host keeps display:block when closed, so measure the sliding panel instead */
  H.isOpen = function () {
    var p = document.querySelector(H.PANEL);
    if (!p) return false;
    var r = p.getBoundingClientRect();
    return r.left < window.innerWidth - 8 && r.right > 8;
  };

  /* fallback for engines without inert support */
  H.stash = function (d) {
    var n = d.querySelectorAll(H.FOCUSABLE);
    for (var i = 0; i < n.length; i++) {
      var e = n[i];
      if (e.hasAttribute('data-cdhide-ti')) continue;
      e.setAttribute('data-cdhide-ti', e.hasAttribute('tabindex') ? e.getAttribute('tabindex') : '');
      e.setAttribute('tabindex', '-1');
    }
  };
  H.unstash = function (d) {
    var n = d.querySelectorAll('[data-cdhide-ti]');
    for (var i = 0; i < n.length; i++) {
      var e = n[i], v = e.getAttribute('data-cdhide-ti');
      if (v === '') e.removeAttribute('tabindex'); else e.setAttribute('tabindex', v);
      e.removeAttribute('data-cdhide-ti');
    }
  };

  H.hide = function () {
    var d = H.drawer();
    if (!d || H.state === 'hidden') return;
    H.state = 'hidden';
    /* stash the modal semantics rather than leaving a permanent dialog at document end */
    if (d.hasAttribute('aria-modal')) { d.setAttribute('data-cd-modal', d.getAttribute('aria-modal')); d.removeAttribute('aria-modal'); }
    if (d.getAttribute('role') === 'dialog') { d.setAttribute('data-cd-role', 'dialog'); d.removeAttribute('role'); }
    if (d.getAttribute('aria-hidden') !== 'true') d.setAttribute('aria-hidden', 'true');
    if (H.hasInert) { if (!d.hasAttribute('inert')) d.setAttribute('inert', ''); } else { H.stash(d); }
    if (d.getAttribute('data-cd-closed') !== '1') d.setAttribute('data-cd-closed', '1');
  };

  H.show = function () {
    var d = H.drawer();
    if (!d) return;
    if (H.hideT) { clearTimeout(H.hideT); H.hideT = null; }
    if (H.state === 'shown') return;
    H.state = 'shown';
    if (d.hasAttribute('data-cd-closed')) d.removeAttribute('data-cd-closed');
    if (d.hasAttribute('inert')) d.removeAttribute('inert');
    if (!H.hasInert) H.unstash(d);
    if (d.getAttribute('aria-hidden') === 'true') d.removeAttribute('aria-hidden');
    if (d.hasAttribute('data-cd-role'))  { d.setAttribute('role', d.getAttribute('data-cd-role')); d.removeAttribute('data-cd-role'); }
    if (d.hasAttribute('data-cd-modal')) { d.setAttribute('aria-modal', d.getAttribute('data-cd-modal')); d.removeAttribute('data-cd-modal'); }
  };

  /* un-hide pre-emptively, before the panel starts moving, so nothing races the open */
  H.PRE = '[data-occ3-cart-icon],[data-occ3-atc-button],a[href*="/cart"],button[type="submit"],' +
          '.spurit-occ3-open,[data-occ3-open]';
  H.pre = function (t) { if (t && t.closest && t.closest(H.PRE)) H.show(); };
  H.onDown   = function (ev) { H.pre(ev.target); };
  H.onKey    = function (ev) { if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') H.pre(ev.target); };
  H.onSubmit = function () { H.show(); };
  document.addEventListener('pointerdown', H.onDown, true);
  document.addEventListener('keydown', H.onKey, true);
  document.addEventListener('submit', H.onSubmit, true);

  H.RX = /\/cart\/(add|change|update|clear)(\.js)?/i;
  if (window.fetch && !window.fetch.__cdhide) {
    var of = window.fetch;
    var wf = function (a) {
      try { var u = (typeof a === 'string') ? a : (a && a.url) || ''; if (H.RX.test(u)) H.show(); } catch (e) {}
      return of.apply(this, arguments);
    };
    wf.__cdhide = 1; H.origFetch = of; window.fetch = wf;
  }
  if (!XMLHttpRequest.prototype.open.__cdhide) {
    var oo = XMLHttpRequest.prototype.open;
    var wo = function (m, u) { try { if (H.RX.test(u || '')) H.show(); } catch (e) {} return oo.apply(this, arguments); };
    wo.__cdhide = 1; H.origOpen = oo; XMLHttpRequest.prototype.open = wo;
  }

  H.tick = function () {
    if (H.isOpen()) {
      if (H.hideT) { clearTimeout(H.hideT); H.hideT = null; }
      H.show();
    } else if (H.state !== 'hidden' && !H.hideT) {
      H.hideT = setTimeout(function () { H.hideT = null; if (!H.isOpen()) H.hide(); }, H.CLOSE_DELAY);
    }
  };
  H.iv = setInterval(H.tick, 50);
  if (!H.isOpen()) H.hide();

  H.teardown = function () {
    clearInterval(H.iv);
    if (H.hideT) clearTimeout(H.hideT);
    document.removeEventListener('pointerdown', H.onDown, true);
    document.removeEventListener('keydown', H.onKey, true);
    document.removeEventListener('submit', H.onSubmit, true);
    if (H.origFetch) window.fetch = H.origFetch;
    if (H.origOpen) XMLHttpRequest.prototype.open = H.origOpen;
    H.state = null; H.show();
    var s = document.getElementById('cdhide-styles'); if (s) s.remove();
  };
})();






